// ⚠️⚠️ BITTA ISTISNO: `@skud/core` ning shu SUBPATH'i (`@core/settings`,
// `packages/core/src/settings.ts`), BARREL EMAS. Boshqa hech qanday frontend
// fayli `@skud/core` ga bog'lanmaydi (`SettingsPage.tsx`, `retention/types`,
// `jobs/utils/tasks.ts` izohlariga qarang) — barrel bullmq/ioredis/pino/
// exceljs ni tortadi va frontend bundle'iga umuman kerak emas.
//
// Bu yerda BOSHQACHA: `settingsMeta.test.ts` (P1 spec §8) `SETTING_KEYS`
// ro'yxatidagi HAR bir kalit shu faylda tasvirlangan bo'lishini tekshiradi
// — ya'ni backend'ga yangi sozlama qo'shilganda frontend meta'si UNUTILGANI
// avtomatik tutiladi (`tables-coverage.test.ts` bilan bir xil naqsh). Bu
// qorovul FAQAT haqiqiy manbadan (`@skud/core/settings`) import qilingan
// ro'yxat bilan ishlaydi — qo'lda ko'chirilgan nusxa drift'ni yashirardi.
// `settings.ts` faylining o'zi HECH NARSA import qilmaydi (sof konstantalar),
// ya'ni bu subpath orqali og'ir server bog'liqliklari frontend'ga TUSHMAYDI.
import type { SettingKey } from "@core/settings";
import type { ReportKind } from "@skud/domain";

export type SettingGroup =
	| "umumiy"
	| "geofence"
	| "yuz_tekshirish"
	| "topshiriq_lid"
	| "retention"
	| "xavf_hisobot";

/**
 * Sahifadagi kartalar tartibi va sarlavhalari (spec §5) — `settings.json`
 * (P7 i18n) dagi `groups.<group>` kaliti, LITERAL matn EMAS.
 * `useTranslation("settings")` bilan `t(SETTING_GROUP_LABEL_KEYS[group])`
 * chaqiriladi (`SettingsPage.tsx`).
 */
export const SETTING_GROUP_LABEL_KEYS: Record<SettingGroup, string> = {
	umumiy: "groups.umumiy",
	geofence: "groups.geofence",
	// biome-ignore lint/style/useNamingConvention: guruh kaliti SettingGroup literali bilan bir xil
	yuz_tekshirish: "groups.yuz_tekshirish",
	// biome-ignore lint/style/useNamingConvention: guruh kaliti SettingGroup literali bilan bir xil
	topshiriq_lid: "groups.topshiriq_lid",
	retention: "groups.retention",
	// biome-ignore lint/style/useNamingConvention: guruh kaliti SettingGroup literali bilan bir xil
	xavf_hisobot: "groups.xavf_hisobot",
};

export const SETTING_GROUP_ORDER: SettingGroup[] = [
	"umumiy",
	"geofence",
	"yuz_tekshirish",
	"topshiriq_lid",
	"retention",
	"xavf_hisobot",
];

/**
 * `labelKey`/`options[].labelKey` — `settings.json` dagi (P7 i18n) kalit
 * yo'li, LITERAL matn EMAS. Chaqiruvchi (`SettingsPage.tsx`,
 * `SettingFieldRenderer.tsx`) `useTranslation("settings")` bilan `t()`ga
 * o'tkazadi.
 */
export type SettingMeta =
	| {
			type: "number";
			group: SettingGroup;
			labelKey: string;
			min: number;
			max: number;
			step?: number;
	  }
	| { type: "boolean"; group: SettingGroup; labelKey: string }
	| {
			type: "enum";
			group: SettingGroup;
			labelKey: string;
			options: { value: string; labelKey: string }[];
	  }
	| { type: "timezone"; group: SettingGroup; labelKey: string }
	| { type: "cron"; group: SettingGroup; labelKey: string };

/**
 * `report_summary_kind` variantlari — `REPORT_DESCRIPTORS` (`@skud/domain`)
 * ning `title`lari bilan QO'LDA sinxron (spec §3 jadvali shu 9 nomni
 * beradi). `REPORT_DESCRIPTORS`ning O'ZI import qilinmaydi: uning
 * `ReportDescriptor` tipida `filters` maydoni bor (`reports/types/index.ts`
 * izohi — server javobida yo'q, faqat backend sxemasida), ya'ni butun
 * xaritani tortish frontend uchun noto'g'ri shakl import qilish bilan bir xil
 * — bu yerda faqat `value`/`labelKey` juftligi kerak. Matnning o'zi
 * `settings.json`ning `fields.report_summary_kind.options` da (P7 i18n) —
 * `reports.json`da bu 9 nom YO'Q (hisobotlar ro'yxati sarlavhalarni
 * backend javobidan oladi, frontend literal saqlamaydi), shuning uchun
 * bu yerda ATAYLAB alohida nusxa.
 */
const REPORT_KIND_OPTIONS: { value: ReportKind; labelKey: string }[] = [
	{ value: "attendance_daily", labelKey: "fields.report_summary_kind.options.attendance_daily" },
	{
		value: "attendance_monthly",
		labelKey: "fields.report_summary_kind.options.attendance_monthly",
	},
	{ value: "lateness", labelKey: "fields.report_summary_kind.options.lateness" },
	{ value: "zone_exits", labelKey: "fields.report_summary_kind.options.zone_exits" },
	{ value: "fake_location", labelKey: "fields.report_summary_kind.options.fake_location" },
	{ value: "work_time", labelKey: "fields.report_summary_kind.options.work_time" },
	{ value: "violations", labelKey: "fields.report_summary_kind.options.violations" },
	{ value: "tasks", labelKey: "fields.report_summary_kind.options.tasks" },
	{ value: "leads", labelKey: "fields.report_summary_kind.options.leads" },
];

/**
 * `notification_channels` ATAYLAB YO'Q (spec §3, §8) — ALOHIDA ekranda
 * (`NotificationChannelsPage`) tahrirlanadi, guruhlangan `SettingsPage`da
 * EMAS: `SettingMeta`ning besh turida ("string" varianti yo'q) kanal
 * xaritasi ifodalanmaydi, yangi variant qo'shish esa bu yagona iste'molchi
 * uchun ortiqcha bo'lardi. `Exclude` bilan tip darajasida ham chiqarib
 * tashlanadi — shu bo'lmasa `Record<SettingKey, SettingMeta>` uni ham
 * talab qilardi.
 *
 * ⚠️ `telegram_bot_username` bu yerda ENDI YO'Q, chunki u umuman
 * `SettingKey` EMAS — botning `@username`i endi tokendan avtomatik
 * aniqlanadi va `SETTING_KEYS`dan tashqarida (`TELEGRAM_BOT_USERNAME_SETTING_KEY`,
 * `packages/core/src/settings.ts`).
 */
export const SETTINGS_META: Record<Exclude<SettingKey, "notification_channels">, SettingMeta> = {
	timezone: { type: "timezone", group: "umumiy", labelKey: "fields.timezone.label" },
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	shift_generation_days: {
		type: "number",
		group: "umumiy",
		labelKey: "fields.shift_generation_days.label",
		min: 1,
		max: 365,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	partition_ahead_months: {
		type: "number",
		group: "umumiy",
		labelKey: "fields.partition_ahead_months.label",
		min: 1,
		max: 24,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	grace_period_min: {
		type: "number",
		group: "geofence",
		labelKey: "fields.grace_period_min.label",
		min: 0,
		max: 240,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	exit_buffer_min: {
		type: "number",
		group: "geofence",
		labelKey: "fields.exit_buffer_min.label",
		min: 0,
		max: 240,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	gps_accuracy_max_m: {
		type: "number",
		group: "geofence",
		labelKey: "fields.gps_accuracy_max_m.label",
		min: 1,
		max: 1000,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	jitter_min_points: {
		type: "number",
		group: "geofence",
		labelKey: "fields.jitter_min_points.label",
		min: 1,
		max: 100,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	jitter_min_seconds: {
		type: "number",
		group: "geofence",
		labelKey: "fields.jitter_min_seconds.label",
		min: 0,
		max: 3600,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	exit_hysteresis_m: {
		type: "number",
		group: "geofence",
		labelKey: "fields.exit_hysteresis_m.label",
		min: 0,
		max: 1000,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	speed_max_kmh: {
		type: "number",
		group: "geofence",
		labelKey: "fields.speed_max_kmh.label",
		min: 1,
		max: 1500,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	time_skew_max_s: {
		type: "number",
		group: "geofence",
		labelKey: "fields.time_skew_max_s.label",
		min: 0,
		max: 86_400,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	sync_max_points_per_batch: {
		type: "number",
		group: "geofence",
		labelKey: "fields.sync_max_points_per_batch.label",
		min: 1,
		max: 10_000,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	exit_decision_max_defers: {
		type: "number",
		group: "geofence",
		labelKey: "fields.exit_decision_max_defers.label",
		min: 1,
		max: 1000,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	offline_sync_threshold_s: {
		type: "number",
		group: "geofence",
		labelKey: "fields.offline_sync_threshold_s.label",
		min: 0,
		max: 86_400,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	offline_alert_hours: {
		type: "number",
		group: "geofence",
		labelKey: "fields.offline_alert_hours.label",
		min: 1,
		max: 168,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	face_match_threshold: {
		type: "number",
		group: "yuz_tekshirish",
		labelKey: "fields.face_match_threshold.label",
		min: 0,
		max: 1,
		step: 0.01,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	face_verify_mode: {
		type: "enum",
		group: "yuz_tekshirish",
		labelKey: "fields.face_verify_mode.label",
		options: [
			{ value: "degraded", labelKey: "fields.face_verify_mode.options.degraded" },
			{ value: "strict", labelKey: "fields.face_verify_mode.options.strict" },
		],
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	task_point_radius_m: {
		type: "number",
		group: "topshiriq_lid",
		labelKey: "fields.task_point_radius_m.label",
		min: 10,
		max: 5000,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	task_arrival_notify: {
		type: "boolean",
		group: "topshiriq_lid",
		labelKey: "fields.task_arrival_notify.label",
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	lead_export_max_rows: {
		type: "number",
		group: "topshiriq_lid",
		labelKey: "fields.lead_export_max_rows.label",
		min: 1,
		max: 1_000_000,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	lead_notify_enabled: {
		type: "boolean",
		group: "topshiriq_lid",
		labelKey: "fields.lead_notify_enabled.label",
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	retention_location_months: {
		type: "number",
		group: "retention",
		labelKey: "fields.retention_location_months.label",
		min: 1,
		max: 240,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	retention_photo_months: {
		type: "number",
		group: "retention",
		labelKey: "fields.retention_photo_months.label",
		min: 1,
		max: 240,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	retention_auto_confirm: {
		type: "boolean",
		group: "retention",
		labelKey: "fields.retention_auto_confirm.label",
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	retention_orphan_min_age_h: {
		type: "number",
		group: "retention",
		labelKey: "fields.retention_orphan_min_age_h.label",
		min: 0,
		max: 8760,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	risk_window_days: {
		type: "number",
		group: "xavf_hisobot",
		labelKey: "fields.risk_window_days.label",
		min: 1,
		max: 365,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	risk_threshold: {
		type: "number",
		group: "xavf_hisobot",
		labelKey: "fields.risk_threshold.label",
		min: 0,
		max: 1000,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	attendance_missing_notify_min: {
		type: "number",
		group: "xavf_hisobot",
		labelKey: "fields.attendance_missing_notify_min.label",
		min: 0,
		max: 1440,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	report_max_range_days: {
		type: "number",
		group: "xavf_hisobot",
		labelKey: "fields.report_max_range_days.label",
		min: 1,
		max: 3660,
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	report_summary_enabled: {
		type: "boolean",
		group: "xavf_hisobot",
		labelKey: "fields.report_summary_enabled.label",
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	report_summary_cron: {
		type: "cron",
		group: "xavf_hisobot",
		labelKey: "fields.report_summary_cron.label",
	},
	// biome-ignore lint/style/useNamingConvention: sozlama kaliti backend bilan bir xil
	report_summary_kind: {
		type: "enum",
		group: "xavf_hisobot",
		labelKey: "fields.report_summary_kind.label",
		options: REPORT_KIND_OPTIONS,
	},
};
